import React from 'react'
import Spinner from './Spinner'
import {createInvoice} from '../share/pdf_invoice_generator'

export default class Invoice extends React.Component {
  constructor(props){
    super(props)
    this.state = {src: null}
  }

  shouldComponentUpdate(nextProps){

    if(!this.state.src || !this.props.order && nextProps.order ||
      this.props.order.id!==nextProps.order.id ||
      !this.props.companyData && nextProps.companyData ||
      this.props.companyData.toString()!==nextProps.companyData.toString()) {
      return true
    }
    return false
  }

  componentDidMount(){
    if(!this.state.src && this.props.order && this.props.companyData) {
      createInvoice(this.props.order,this.props.companyData).then((data) => {
        this.setState({src: data})
      })
    }
  }

  render(){
    return(
      <React.Fragment>
        {!!this.state.src
          ? <iframe src={this.state.src} width={'780px'} height={'1200px'}/>
          : <Spinner text='generiere PDF'/>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/Invoice.js